import { render, staticRenderFns } from "./PastizalParaguai.vue?vue&type=template&id=1b211eaf&lang=pug"
import script from "./PastizalParaguai.vue?vue&type=script&lang=js"
export * from "./PastizalParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports